import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import DashboardLayoutMain from "../../../layout/dashboard/DashboardLayoutMain";
import TabLink from "../../../components/fragment/tab-link/TabLink";
import RootState from "../../../redux/type";
import { ALL_ROUTES } from "../../../routes/AllRoutes";
import ReferralOverview from "./tabs/overview";
import InfluencerProgram from "./tabs/influencer-program";
import Promotions from "./tabs/promotions";
import ReferralSettings from "./tabs/referral-setting";

export default function ReferralIndex() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useSelector((state: RootState) => state.auth);
  const [activeTab, setActiveTab] = useState(
    (location.state as { activeTab?: string } | null)?.activeTab || "Overview",
  );

  const canViewPromotions = !!user?.permissions?.includes("view_promotion");
  const canViewInfluencers = !!user?.permissions?.includes(
    "view_influencer_contract",
  );

  // redirect if user has no permission to access the referral module at all
  useEffect(() => {
    if (
      !user?.permissions?.includes("view_referral_setting") &&
      user?.permissions?.length > 0
    ) {
      navigate(ALL_ROUTES.DASHBOARD_OVERVIEW);
    }
  }, [user?.permissions]);

  // fall back to a tab the user can actually see if the active one becomes unavailable
  useEffect(() => {
    if (activeTab === "Promotions" && !canViewPromotions) {
      setActiveTab("Overview");
    }
    if (activeTab === "Influencer Programme" && !canViewInfluencers) {
      setActiveTab("Overview");
    }
  }, [activeTab, canViewPromotions, canViewInfluencers]);

  const tabLinkList = [
    {
      label: "Overview",
      active: activeTab === "Overview",
    },
    {
      label: "Referral Settings",
      active: activeTab === "Referral Settings",
    },
    canViewPromotions && {
      label: "Promotions",
      active: activeTab === "Promotions",
    },
    canViewInfluencers && {
      label: "Influencer Programme",
      active: activeTab === "Influencer Programme",
    },
  ].filter(Boolean) as { label: string; active: boolean }[];

  return (
    <DashboardLayoutMain title="Referral">
      <section className="bg-white mx-[2rem] pt-[10px] space-y-4 mt-[15px]">
        <TabLink
          onClick={(param) => {
            setActiveTab(param?.label);
          }}
          list={tabLinkList}
          className="single-customer-tab-link"
        />
      </section>
      <div className="smart-send-single-customer-detail-wrapper-index">
        {activeTab === "Overview" && <ReferralOverview />}
        {activeTab === "Referral Settings" && <ReferralSettings />}
        {activeTab === "Promotions" && canViewPromotions && <Promotions />}
        {activeTab === "Influencer Programme" && canViewInfluencers && (
          <InfluencerProgram />
        )}
      </div>
    </DashboardLayoutMain>
  );
}
